import gql from 'graphql-tag';
export const getProductsData = gql`
  query GetAllProductsData {
    productsAll {
      id
      name
      barcode
      code
      stockQuantity
      measurementUnit
      wholesalePrice
      retailPrice
      price
      discount1
      discount2
      decimal
      quantityUnit
      packaging
      weight
      tarifnaGrupa
      color
      colorDescription
      division
      brand
      category
      parentCategory
      categoryCode
      parentCategoryCode
      isPos
      isTobacco
      channels
      inAssortment
      eans {
        id
        ean
      }
    }
    customersCategories {
      id
      product
      category
    }
    hierarchicalCategories {
      id
      name
      code
      childrens {
        id
        name
        code
      }
    }
    productStocks
    productGroups
    productSpecCategories
    productDeliveryHistoryByUser
  }
`;